export default __webpack_public_path__ + "static/small-banner-1b2b97bc8f94a697fb6441633383d47d.jpg";